export default __webpack_public_path__ + "static/media/proxyway-logo.24baab8d.svg";